
import { Vue } from "vue-class-component";

export default class Shortland extends Vue {}
